import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const GolfIcon = observer('GolfIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            className={className}
            onClick={onClick}
        >
            <mask
                id='golfMask'
                width='10'
                height='14'
                x='3'
                y='1'
                maskUnits='userSpaceOnUse'
                style={{ maskType: 'alpha' }}
            >
                <path
                    fill='#142448'
                    d='M8 10.767q-1.95 0-3.308-1.359Q3.333 8.05 3.333 6.1t1.359-3.308T8 1.433t3.308 1.359Q12.667 4.15 12.667 6.1t-1.359 3.308Q9.95 10.767 8 10.767M6.667 6.1a.65.65 0 0 0 .475-.192.65.65 0 0 0 .191-.475.65.65 0 0 0-.191-.475.65.65 0 0 0-.475-.191.65.65 0 0 0-.475.191.65.65 0 0 0-.192.475q0 .285.192.475a.65.65 0 0 0 .475.192m2.666 0a.65.65 0 0 0 .475-.192.65.65 0 0 0 .192-.475.65.65 0 0 0-.192-.475.65.65 0 0 0-.475-.191.65.65 0 0 0-.475.191.65.65 0 0 0-.191.475q0 .285.191.475a.65.65 0 0 0 .475.192M8 4.767a.65.65 0 0 0 .475-.192.65.65 0 0 0 .192-.475.65.65 0 0 0-.192-.475A.65.65 0 0 0 8 3.433a.65.65 0 0 0-.475.192.65.65 0 0 0-.192.475q0 .283.192.475A.65.65 0 0 0 8 4.767m-.667 10V14.1q0-.55-.391-.942A1.28 1.28 0 0 0 6 12.767H4.667v-1.334h6.666v1.334H10q-.55 0-.942.391a1.28 1.28 0 0 0-.391.942v.667z'
                />
            </mask>
            <g mask='url(#golfMask)'>
                <path
                    fill='#0b1627'
                    fillOpacity='.64'
                    d='M0 0h16v16H0z'
                />
            </g>
        </SvgElement>
    );
});
